import { render, staticRenderFns } from "./ProductPicker.vue?vue&type=template&id=b8a82f76&scoped=true"
import script from "./ProductPicker.vue?vue&type=script&lang=ts"
export * from "./ProductPicker.vue?vue&type=script&lang=ts"
import style0 from "./ProductPicker.vue?vue&type=style&index=0&id=b8a82f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a82f76",
  null
  
)

export default component.exports